"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class InvalidMonthYearError extends client_library_1.ExtendableError {
    constructor(month, year) {
        super(`Invalid month year provided: ${month}/${year}`);
        this.month = month;
        this.year = year;
    }
}
exports.default = InvalidMonthYearError;
//# sourceMappingURL=InvalidMonthYearError.js.map